import React from 'react';
import noop from '../utils/noop';
import { useDeviationMatureFilter } from '../utils/hooks/useDeviationMatureFilter';
import { PapiDeviation } from '@wix/da-papi-types';

export type MatureDeviationContextProps = ReturnType<
  typeof useDeviationMatureFilter
>;

export const MatureDeviationContext =
  React.createContext<MatureDeviationContextProps>({
    showBlocked: false,
    displayReason: undefined,
    overrideMatureFilter: noop,
  });
MatureDeviationContext.displayName = 'MatureDeviationContext';

export const MatureDeviationContextProvider: React.FC<{
  deviation: PapiDeviation;
  children: React.ReactNode;
}> = ({ children, deviation }) => {
  const matureFilter = useDeviationMatureFilter(deviation);
  return (
    <MatureDeviationContext.Provider value={matureFilter}>
      {children}
    </MatureDeviationContext.Provider>
  );
};
MatureDeviationContextProvider.displayName = 'MatureDeviationContextProvider';
